import { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import Button from '@mui/material/Button';
import { SelectChangeEvent } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import ConfirmModal from 'src/components/ConfirmModal';
import {
  ASSET_TYPE,
  useGetVerificationRejectReason,
} from 'src/pages/VerificationsPage/api';

import messages from './messages';

export default function VerificationDeclineForm({
  assetType,
  onConfirm,
  loading,
  disabled,
}: {
  assetType: ASSET_TYPE | string;
  onConfirm: (reason_code: string) => void;
  loading: boolean;
  disabled: boolean;
}) {
  const { formatMessage } = useIntl();

  const [isOpen, setOpen] = useState(false);

  const [reasonCode, setReasonCode] = useState<string>('');

  const { data } = useGetVerificationRejectReason(
    { asset_type: assetType },
    { enabled: isOpen },
  );

  useEffect(() => {
    if (isOpen) {
      setReasonCode('');
    }
  }, [isOpen]);

  const handleClose = useCallback(() => {
    setOpen(false);
    setReasonCode('');
  }, []);

  const onChangeEventValue = useCallback(
    (event: SelectChangeEvent<unknown>) => {
      const { value } = event.target as { value: string };

      setReasonCode(value);
    },
    [],
  );
  const handleSubmit = useCallback(() => {
    onConfirm(reasonCode);
  }, [reasonCode, onConfirm]);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  return (
    <ConfirmModal
      title={formatMessage(messages.declineTitle)}
      onConfirm={handleSubmit}
      maxWidth="550px"
      open={isOpen}
      onClose={handleClose}
      loading={loading}
      disabled={!reasonCode}
      triggerButton={() => (
        <Button color="error" onClick={handleOpen} disabled={disabled}>
          {formatMessage(messages.declineButton)}
        </Button>
      )}
    >
      <RadioGroup
        defaultValue=""
        name="radio-buttons-group"
        onChange={onChangeEventValue}
      >
        {data?.map((item) => {
          return (
            <FormControlLabel
              key={item.value}
              value={item.value}
              control={<Radio />}
              label={item.label}
            />
          );
        })}
      </RadioGroup>
    </ConfirmModal>
  );
}
